import Api from "../services/AxiosService";
import { unwrap } from "./envelope";

// svc-04 `/v1/admin/cad3d-settings` (gateway routes /v1/admin/* to admin-config).
// Distinct from svc-09's runtime /v1/cad/settings endpoint.

export interface Cad3dSettingsAdmin {
  id: number;
  tessellationMode: string | null;
  bboxRatio: number | null;
  linearDeflectionMm: number | null;
  angularDeflection: number | null;
  matchThreshold: number;
  bboxDiagGateRatio: number;
  maxFileBytes: number;
  signatureVersion: string;
  createdAt: string;
  updatedAt: string;
  createdBy: string | null;
  updatedBy: string | null;
}

export type UpdateCad3dSettingsAdminBody = Partial<{
  tessellationMode: string;
  bboxRatio: number;
  linearDeflectionMm: number;
  angularDeflection: number;
  matchThreshold: number;
  bboxDiagGateRatio: number;
  maxFileBytes: number;
}>;

const BASE = "/v1/admin/cad3d-settings";

export async function getCad3dSettingsAdmin(): Promise<Cad3dSettingsAdmin> {
  const res = await Api.get(BASE);
  return unwrap<Cad3dSettingsAdmin>(res.data);
}

export async function patchCad3dSettingsAdmin(
  body: UpdateCad3dSettingsAdminBody,
): Promise<Cad3dSettingsAdmin> {
  const res = await Api.patch(BASE, body);
  return unwrap<Cad3dSettingsAdmin>(res.data);
}
